import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Spinner from "../../components/BootstrapCompo";
import { handleError } from "../../context/Provider";
import henceforthApi from "../../utils/henceforthApi";
import BreadCrumb from "../../components/common/BreadCrumb";

const AppConfig = () => {
    const [loading, setLoading] = useState(false);
    const [fetching, setFetching] = useState(true);
    const [configData, setConfigData] = useState({
        platform_fee: 0,
        commission: 0,
        commission_type: "PERCENTAGE",
        delivery: {
            base_fee: 0,
            base_distance_km: 0,
            per_km_fee: 0,
            tax: 0
        },
        tax: 0
    });

    const breadCrumbPath = [
        { name: 'Home', url: `/`, active: '' },
        // { name: 'Settings', url: `/setting`, active: '' },
        { name: 'App Config', url: ``, active: 'not-allowed' }
    ];

    const fetchAppConfig = async () => {
        setFetching(true);
        try {
            const apiRes = await henceforthApi.AppConfig.getAppConfig();
            if (apiRes?.data) {
                setConfigData({
                    platform_fee: apiRes.data.platform_fee || 0,
                    commission: apiRes.data.commission || 0,
                    commission_type: apiRes.data.commission_type || "PERCENTAGE",
                    delivery: {
                        base_fee: apiRes.data.delivery?.base_fee || 0,
                        base_distance_km: apiRes.data.delivery?.base_distance_km || 0,
                        per_km_fee: apiRes.data.delivery?.per_km_fee || 0,
                        tax: apiRes.data.delivery?.tax || 0
                    },
                    tax: apiRes.data.tax || 0
                });
            }
        } catch (error) {
            handleError(error);
        } finally {
            setFetching(false);
        }
    };

    useEffect(() => {
        fetchAppConfig();
    }, []);

    const handleInputChange = (field: string, value: number | string) => {
        setConfigData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleDeliveryChange = (field: string, value: number) => {
        setConfigData(prev => ({
            ...prev,
            delivery: {
                ...prev.delivery,
                [field]: value
            }
        }));
    };

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        
        // Validation
        if (configData.platform_fee < 0 || configData.platform_fee > 100) {
            return toast.error("Platform fee must be between 0 and 100");
        }
        if (configData.commission < 0 || configData.commission > 100) {
            return toast.error("Commission must be between 0 and 100");
        }
        if (configData.tax < 0 || configData.tax > 100) {
            return toast.error("Tax must be between 0 and 100");
        }
        if (configData.delivery.base_fee < 0) {
            return toast.error("Base fee cannot be negative");
        }
        if (configData.delivery.base_distance_km < 0) {
            return toast.error("Base distance cannot be negative");
        }
        if (configData.delivery.per_km_fee < 0) {
            return toast.error("Per km fee cannot be negative");
        }
        if (configData.delivery.tax < 0 || configData.delivery.tax > 100) {
            return toast.error("Delivery tax must be between 0 and 100");
        }

        setLoading(true);
        const data = {
            platform_fee: Number(configData.platform_fee),
            commission: Number(configData.commission),
            commission_type: configData.commission_type,
            delivery: {
                base_fee: Number(configData.delivery.base_fee),
                base_distance_km: Number(configData.delivery.base_distance_km),
                per_km_fee: Number(configData.delivery.per_km_fee),
                tax: Number(configData.delivery.tax)
            },
            tax: Number(configData.tax)
        };

        try {
            const apiRes = await henceforthApi.AppConfig.updateAppConfig(data);
            toast.success(apiRes.message || "App configuration updated successfully");
            fetchAppConfig();
        } catch (error: any) {
            handleError(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <BreadCrumb pathNameDeclare={breadCrumbPath} />

            <div className='page-spacing'>
                <section className='edit-profile'>
                    <div className="container-fluid">
                        <div className="row justify-content-center">
                            <div className="col-sm-12 col-md-10 col-lg-8 col-xl-8">
                                <div className="common-card">
                                    <div className="common-card-title">
                                        <h5>App Configuration</h5>
                                    </div>
                                    <div className="common-card-content">
                                        {fetching ? (
                                            <div className="text-center py-4">
                                                <Spinner />
                                            </div>
                                        ) : (
                                            <form onSubmit={handleSubmit}>
                                                {/* Platform Fee */}
                                                <div className='form-fields-box mb-3'>
                                                    <label>Platform Fee</label>
                                                    <input
                                                        type="number"
                                                        className="form-control rounded-0"
                                                        value={configData.platform_fee}
                                                        onChange={(e) => handleInputChange("platform_fee", Number(e.target.value))}
                                                        placeholder="Enter platform fee"
                                                        min="0"
                                                        max="100"
                                                        required
                                                    />
                                                </div>

                                                {/* Commission */}
                                                <div className='form-fields-box mb-3'>
                                                    <label>Commission from seller</label>
                                                    <input
                                                        type="number"
                                                        className="form-control rounded-0"
                                                        value={configData.commission}
                                                        onChange={(e) => handleInputChange("commission", Number(e.target.value))}
                                                        placeholder="Enter commission"
                                                        min="0"
                                                        max="100"
                                                        required
                                                    />
                                                </div>

                                                {/* Commission Type */}
                                                <div className='form-fields-box mb-3'>
                                                    <label>Commission Type:</label>
                                                    <select
                                                        className="form-select rounded-0"
                                                        value={configData.commission_type}
                                                        onChange={(e) => handleInputChange("commission_type", e.target.value)}
                                                        required
                                                    >
                                                        <option value="PERCENTAGE">PERCENTAGE</option>
                                                        {/* <option value="FIXED">FIXED</option> */}
                                                    </select>
                                                </div>

                                                {/* Tax */}
                                                {/* <div className='form-fields-box mb-3'>
                                                    <label>Tax (%):</label>
                                                    <input
                                                        type="number"
                                                        className="form-control rounded-0"
                                                        value={configData.tax}
                                                        onChange={(e) => handleInputChange("tax", Number(e.target.value))}
                                                        placeholder="Enter tax"
                                                        min="0"
                                                        max="100"
                                                        required
                                                    />
                                                </div> */}

                                                {/* Delivery Section */}
                                                <div className="mb-4">
                                                    <h6 className="fw-bold mb-3">Delivery Settings</h6>
                                                    
                                                    <div className='form-fields-box mb-3'>
                                                        <label>Base Fee:</label>
                                                        <input
                                                            type="number"
                                                            className="form-control rounded-0"
                                                            value={configData.delivery.base_fee}
                                                            onChange={(e) => handleDeliveryChange("base_fee", Number(e.target.value))}
                                                            placeholder="Enter base fee"
                                                            min="0"
                                                            required
                                                        />
                                                    </div>

                                                    <div className='form-fields-box mb-3'>
                                                        <label>Base Distance (km):</label>
                                                        <input
                                                            type="number"
                                                            className="form-control rounded-0"
                                                            value={configData.delivery.base_distance_km}
                                                            onChange={(e) => handleDeliveryChange("base_distance_km", Number(e.target.value))}
                                                            placeholder="Enter base distance in km"
                                                            min="0"
                                                            required
                                                        />
                                                    </div>

                                                    <div className='form-fields-box mb-3'>
                                                        <label>Per KM Fee:</label>
                                                        <input
                                                            type="number"
                                                            className="form-control rounded-0"
                                                            value={configData.delivery.per_km_fee}
                                                            onChange={(e) => handleDeliveryChange("per_km_fee", Number(e.target.value))}
                                                            placeholder="Enter per km fee"
                                                            min="0"
                                                            required
                                                        />
                                                    </div>

                                                    <div className='form-fields-box mb-3'>
                                                        <label>Delivery Tax (%):</label>
                                                        <input
                                                            type="number"
                                                            className="form-control rounded-0"
                                                            value={configData.delivery.tax}
                                                            onChange={(e) => handleDeliveryChange("tax", Number(e.target.value))}
                                                            placeholder="Enter delivery tax"
                                                            min="0"
                                                            max="100"
                                                            required
                                                        />
                                                    </div>
                                                </div>

                                                {/* Submit Button */}
                                                <div className='signin-button-box'>
                                                    <button type='submit' className='btn btn-theme w-100' disabled={loading}>
                                                        {loading ? <Spinner /> : <span><i className='fa fa-save me-2'></i>Update Configuration</span>}
                                                    </button>
                                                </div>
                                            </form>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default AppConfig;
